import {
    FETCH_GROUPS,
    FETCH_ADMINISTERED_GROUPS,
    FETCH_GROUP_REQUESTS,
    FETCH_UNHANDLED_GROUP_REQUESTS,
    LEAVE_GROUP,
    DELETE_GROUP,
    RESET_GROUPS,
    SEARCH_GROUP,
    UPDATE_GROUP_SEARCH_KEYWORD,
    JOIN_GROUP,
    CANCEL_REQUEST_JOIN_GROUP,
    FETCH_GROUP_MEMBER,
    SET_GROUP_LIST_PAGE_TAB
} from './ActionTypes';

export const fetchGroups = (displayName, evictCache) => ({
    type: FETCH_GROUPS,
    displayName,
    meta: {
        cacheTime: evictCache ? null : 1000
    }
});

export const fetchAdministeredGroups = (displayName, evictCache) => ({
    type: FETCH_ADMINISTERED_GROUPS,
    displayName,
    meta: {
        cacheTime: evictCache ? null : 1000
    }
});

export const fetchGroupRequests = (displayName, evictCache) => ({
    type: FETCH_GROUP_REQUESTS,
    displayName,
    meta: {
        cacheTime: evictCache ? null : 1000
    }
});

export const fetchUnhandledGroupRequests = (displayName, evictCache) => ({
    type: FETCH_UNHANDLED_GROUP_REQUESTS,
    displayName,
    meta: {
        cacheTime: evictCache ? null : 1000
    }
});

export const leaveGroup = (groupId, profileId) => ({
    type: LEAVE_GROUP,
    groupId,
    profileId
});

export const deleteGroup = (groupId) => ({
    type: DELETE_GROUP,
    groupId
});

export const resetGroups = () => ({
    type: RESET_GROUPS
});

export const searchGroup = ({ encodedKeyword, reset = false, forceSearch = false }, evictCache) => ({
    type: SEARCH_GROUP,
    encodedKeyword,
    reset,
    forceSearch,
    meta: {
        cacheTime: evictCache ? null : 1000
    }
});

export const updateGroupSearchKeyword = (keyword) => ({
    type: UPDATE_GROUP_SEARCH_KEYWORD,
    keyword
});

export const joinGroup = ({ groupId, userProfileId, joinType }) => ({
    type: JOIN_GROUP,
    groupId,
    userProfileId,
    joinType
});

export const cancelRequestJoinGroup = ({ groupId, groupMemberRequestId }) => ({
    type: CANCEL_REQUEST_JOIN_GROUP,
    groupId,
    groupMemberRequestId
});

export const fetchGroupMember = (groupId, userProfileId) => ({
    type: FETCH_GROUP_MEMBER,
    groupId: groupId,
    userProfileId: userProfileId
});

export const setGroupListPageTab = (tab) => ({
    type: SET_GROUP_LIST_PAGE_TAB,
    tab
});
